import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'
import style from './style.css'
import EmployeesSelector from '/app/src/model/Employee/selector'
import Item from './Item'


class TransferModal extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            online: !this.props.online.isEmpty()
        }
        this._renderEmployees = this._renderEmployees.bind(this)
    }

    _renderEmployees(employees){
        // For each employee in employees, return an item-element with the employee's properties.
        // TODO: Understand and document structure of "employees"
        return employees.valueSeq().toJS().map((employee) => {
            return <Item key={employee.id} employee={employee} room={this.props.room}/>
        })
    }


    render(){
        const online = this.props.online
        const offline = this.props.offline
        return (
            <Flex className={style.Modal} hAlignContent='left' column>
                {this._renderEmployees(online)}
                <Flex backgroundColor='#f7f7f7' center color='black' h='30px' shrink={0} w='100%' fontSize='20px' fontWeight='500'> Offline ({this.props.offline.size})
                </Flex>
                {this._renderEmployees(offline)}
            </Flex>
        )
    }
}

function mapStateToProps(state, ownProps){
    const room = ownProps.data.room
    return {
        room: room,
        online: EmployeesSelector.getOnlineCoworkers(state),
        offline: EmployeesSelector.getOfflineCoworkers(state)
    }
}

export default connect(mapStateToProps)(TransferModal);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Modal/Transfer/index.js